module.exports = __webpack_public_path__ + "img/icon_account.bca34d03.png";